<template>
    <div class="ml-3 text-left">
        <label
            for="first_name"
            class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
            >{{ label }}</label
        >
        <date-picker v-model="date">
            <template v-slot="{ inputValue, togglePopover }">
                <div class="inline-flex flex-grow-0 ">
                    <input
                        :value="inputValue"
                        placeholder="JJ / MM / AAAA"
                        class="block w-40 h-8 p-2 placeholder-gray-800 transition duration-150 ease-in-out border-b-2 border-gray-300 sm:text-base sm:leading-5"
                    />
                    <button
                        class="p-2 text-blue-600 hover:bg-blue-200 focus:bg-blue-500 focus:text-white focus:border-blue-500 focus:outline-none"
                        @click="togglePopover({ placement: 'auto-start' })"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            class="w-6 h-6 fill-current"
                        >
                            <path
                                d="M1 4c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z"
                            ></path>
                        </svg>
                    </button>
                </div>
            </template>
        </date-picker>
    </div>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";
export default {
    components: {
        DatePicker
    },
    props: {
        label: {
            type: String,
            required: true
        },
        value: {
            required: true
            // type: Date,
        }
    },
    data() {
        return {
            date: this.value ? this.value : null
        };
    },
    watch: {
        date: function(newDate) {
            this.$emit("setDate", newDate);
        }
    }
};
</script>

<style></style>
